import type { SlideshowConfig } from "@/models"
import { useMutation } from "@tanstack/vue-query"
import { v1 } from "@/axios"

interface UseUpdateSlideshowConfigArgs {
  slideshowConfig: SlideshowConfig
  eventVaultId: number
}

export async function updateSlideshowConfig(slideshowConfig: SlideshowConfig, eventVaultId: number) {
  return v1.patch(`/${eventVaultId}/slideshow/${slideshowConfig.id}`, slideshowConfig.toRequest())
}

export function useUpdateSlideshowConfig() {
  return useMutation({
    mutationFn: ({ slideshowConfig, eventVaultId }: UseUpdateSlideshowConfigArgs) =>
      updateSlideshowConfig(slideshowConfig, eventVaultId),
  })
}
